import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    // 버전관리 하는 파일 get-api
    async getFile ({ state }, data) {
      const site = data.site
      const id = site ? `${store.state.authentication.requestId.split('.')[0]}.${site}` : store.state.authentication.requestId
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-file-version',
          method: 'get',
          func: 'gvf',
          id: id,
          file: data.file, // 파일경로/파일명
          ...data.version && {
            version: data.version
          }
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    },
    // 버전관리 하는 파일 set-api
    async setFile ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-file-version',
          method: 'set',
          func: 'gvf',
          id: store.state.authentication.requestId,
          file: data.file, // 파일경로/파일명
          data: JSON.stringify(data.data),
          origin_version: data.origin_version || 0,
          last_version: data.last_version || 0,
          ...data.force && {
            force: data.force || false
          },
          ...data.comment && {
            comment: data.comment
          }
        })
        return res.data.message
          ? res.data
          : (res.data.errorMessage ? JSON.parse(res.data.errorMessage) : null)
      } catch (ex) {
        // console.error('error:', ex)
        alert(ex)
        console.log(ex)
        return ex.response.data
      }
    },
    async getFileVersion ({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-file-version',
          method: 'get-all',
          func: 'gvf',
          id: store.state.authentication.requestId,
          file: data.file // 파일경로/파일명
        })
        return res.data.message
      } catch (ex) {
        return ex.response.data
      }
    }
  },
  getters: {
  }
}
